export default __webpack_public_path__ + "static/media/step2.cd22c79c.png";